import { useAtomValue } from 'jotai';
import { useCollectionQuery } from 'lib-knowledge-management-common/graphql';
import { collectionIdAtom } from 'models/collectionStore';

type UseCollectionReturnValue = ReturnType<typeof useCollectionQuery>;

function useCollectionFetch({
  collectionId,
}: {
  collectionId?: string;
} = {}): UseCollectionReturnValue {
  const globalCollectionId = useAtomValue(collectionIdAtom);

  return useCollectionQuery({
    variables: {
      id: collectionId || globalCollectionId || '',
    },
    skip: !collectionId && !globalCollectionId,
    fetchPolicy: 'cache-and-network',
  });
}

export default useCollectionFetch;
